import React, { SVGProps } from 'react';

const VIPRewardsIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.33333 3.16634H17.3333C18.0697 3.16634 18.6667 3.76329 18.6667 4.49967V5.16634V5.83301C18.6667 6.56939 18.0697 7.16634 17.3333 7.16634H14.6667H5.33333C4.59695 7.16634 4 6.56939 4 5.83301V5.16634V4.49967C4 3.76329 4.59695 3.16634 5.33333 3.16634ZM3.02342 7.16634C2.79653 6.77411 2.66667 6.31872 2.66667 5.83301V5.16634V4.49967C2.66667 3.02692 3.86057 1.83301 5.33333 1.83301H17.3333C18.8061 1.83301 20 3.02692 20 4.49967V5.16634V5.83301C20 7.30577 18.8061 8.49967 17.3333 8.49967H16.9766C17.2035 8.89191 17.3333 9.34729 17.3333 9.83301V10.4997V11.1663C17.3333 11.6521 17.2035 12.1074 16.9766 12.4997H17.3333C18.8061 12.4997 20 13.6936 20 15.1663V15.833V16.4997C20 17.9724 18.8061 19.1663 17.3333 19.1663H5.33333C3.86057 19.1663 2.66667 17.9724 2.66667 16.4997V15.833V15.1663C2.66667 14.6806 2.79653 14.2252 3.02342 13.833H2.66667C1.19391 13.833 0 12.6391 0 11.1663V10.4997V9.83301C0 8.36025 1.19391 7.16634 2.66667 7.16634H3.02342ZM14.6667 8.49967H5.33333H2.66667C1.93029 8.49967 1.33333 9.09663 1.33333 9.83301V10.4997V11.1663C1.33333 11.9027 1.93029 12.4997 2.66667 12.4997H5.33333H14.6667C15.403 12.4997 16 11.9027 16 11.1663V10.4997V9.83301C16 9.09663 15.403 8.49967 14.6667 8.49967ZM4 15.1663C4 14.43 4.59695 13.833 5.33333 13.833H14.6667H17.3333C18.0697 13.833 18.6667 14.43 18.6667 15.1663V15.833V16.4997C18.6667 17.2361 18.0697 17.833 17.3333 17.833H5.33333C4.59695 17.833 4 17.2361 4 16.4997V15.833V15.1663Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default VIPRewardsIcon;
